module.exports = __webpack_public_path__ + "static/media/sales-simplify-logo.10cd23f5.svg";